import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import PDFPreviewModal from '../../Components/PdfViewModal'




const ArticleDetail: React.FC = () => {
    const history = useHistory();
    const { dataId, articleId } = useParams<{ dataId: string; articleId: string }>();

    // 动态引入对应的 JSON 文件
    const dataFile = require(`../../data/data${dataId}.json`);

    // 根据 articleId 筛选数据
    const filteredData = dataFile.find((item: any) => item.id === Number(articleId));
    console.log(dataFile);
    console.log(filteredData);

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>文章详情</h1>
                {
                    filteredData.ispdf && <div
                        className='content-container'

                    >
                        <PDFPreviewModal
                            fileName={filteredData.title}
                            fileUrl={'/' + filteredData.url}
                            onCancel={() => {}}
        />
                    </div>
                }
                {
                    !filteredData.ispdf && <div
                        className='content-container'
                        dangerouslySetInnerHTML={{ __html: filteredData?.content || '' }}
                    >
                    </div>
                }

            </div>
        } />
    );
};

export default ArticleDetail;